import React, { FC } from 'react'
import { flatten } from '@utils/string-helper'
import './card.css'


export interface CardProps extends React.HTMLAttributes<HTMLDivElement> {
    header?: React.ReactNode
    light?: boolean
}

const Card: FC<CardProps> = (props) => {
    const { className: classProps, children, header, light, ...divProps } = props
    const className = flatten("card", { light }, classProps)

    return (
        <div className={className} {...divProps}>
            {header && <div className='header'>{header}</div>}
            <div className='body'>{children}</div>
        </div>
    )
}

export default Card
